<template>
  <div class="p-3 mb-md-0 mb-4" ref="dropdownContent">
        <div class="input-and-submit-wrapper form-group">
            <div class="form-icon">
                <i class="fas fa-search"></i>
            </div>
            <input type="text" class="has-icon form-control" name="group-name" id="group-name" v-model="hotelName"
                autocomplete="off" placeholder="Search" />
        </div>

        <div class="d-flex filters justify-content-center mb-3">
            <a href="#" class="px-2" @click.prevent.stop="setFilter('trial')"
                :class="currentFilter == 'trial' ? 'border-bottom font-weight-bold text-primary' : ''">{{ __("Trial") }}</a>
            <a href="#" class="px-2" @click.prevent.stop="setFilter('subscribed')"
                :class="currentFilter == 'subscribed' ? 'border-bottom font-weight-bold text-primary' : ''">{{ __("Subscribed") }}</a>
            <a href="#" class="px-2" @click.prevent.stop="setFilter('group')"
                :class="currentFilter == 'group' ? 'border-bottom font-weight-bold text-primary' : ''">{{ __("Groups") }}</a>
            <a href="#" class="px-2" @click.prevent.stop="setFilter('all')"
                :class="currentFilter == 'all' ? 'border-bottom font-weight-bold text-primary' : ''">{{ __("All") }}</a>
        </div>

        <!-- Groups List -->
        <div v-if="currentFilter === 'group'">
            <div v-for="(group, index) in filteredGroups" :key="'group-' + group.id" class="dropdown-item"
                v-if="group.filteredTeams.length > 0">
                <div class="group-header cursor-pointer" @click="toggleGroup(index)">
                    <a href="javascript:void(0)">{{ group.name }}</a>
                    <i :class="{
                        'fas fa-chevron-down': !openGroups.includes(index),
                        'fas fa-chevron-up': openGroups.includes(index)
                    }" class="ml-2"></i>
                </div>
                <div v-if="openGroups.includes(index)" class="group-teams">
                    <div v-for="team in group.filteredTeams" :key="'group-' + group.id + '-team-' + team.id"
                        class="dropdown-item">
                        <a :href="'/settings/hotels/' + team.id + '/switch'">
                            <span v-if="user.current_team_id == team.id">
                                <i class="fa fa-fw text-left fa-btn fa-check text-success"></i>
                                {{ team.name }}
                            </span>
                            <span v-else>
                                <img :src="team.photo_url" class="spark-profile-photo-xs align-middle" />
                                {{ team.name }}
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Teams List -->
        <div v-if="currentFilter !== 'group'">
            <a v-for="team in filteredTeams" :key="'team-' + team.id"
                class="dropdown-item" 
                :href="'/settings/hotels/' + team.id + '/switch'"
            >
                <span v-if="user.current_team_id == team.id">
                    <i class="fa fa-fw text-left fa-btn fa-check text-success"></i>
                    {{ team.name }}
                </span>
                <span v-else>
                    <img :src="team.photo_url" class="spark-profile-photo-xs align-middle" /> {{ team.name }}
                </span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        filteredTeams() {
            const uniqueTeamIds = new Set();
            return this.teams
                .filter(team => (this.hotelName.length === 0 || team.name.toLowerCase().includes(this.hotelName.toLowerCase())))
                .filter(team => (this.currentFilter === 'all' || team.status === this.currentFilter))
                .filter(team => {
                    if (!uniqueTeamIds.has(team.id)) {
                        uniqueTeamIds.add(team.id);
                        return true;
                    }
                    return false;
                });
        },
        filteredGroups() {
            return this.spark.state.groups
                .map(group => {
                    const filteredTeams = group.group_teams.filter(team => {
                        return team.name.toLowerCase().includes(this.hotelName.toLowerCase());
                    });
                    return { ...group, filteredTeams };
                })
                .filter(group => group.filteredTeams.length > 0); // Exclude groups with no teams
        }
    },
    watch: {
        hotelName() {
            if (this.currentFilter === 'group' && this.hotelName.length > 0) {
                this.openGroups = this.filteredGroups.map((_, index) => index); // Open all groups when searching
            } else {
                this.openGroups = []; // Reset open groups when not searching
            }
        }
    },
    data() {
        return {
            currentFilter: "trial",
            hotelName: "",
            openGroups: [] // Track open group indexes
        };
    },
    mounted() {
        this.$refs.dropdownContent.addEventListener('click', function (event) {
            event.stopPropagation();
        });
    },
    beforeDestroy() {
        this.$refs.dropdownContent.removeEventListener('click', this.stopProp);
    },
    props: {
        teams: Array,
        user: Object,
    },
    methods: {
        setFilter(value) {
            this.currentFilter = value;
            if (this.hotelName.length > 0 && value === 'group') {
                this.openGroups = this.filteredGroups.map((_, index) => index); // Open all groups when searching
            } else {
                this.openGroups = []; // Reset open groups when not searching
            }
        },
        toggleGroup(index) {
            if (this.openGroups.includes(index)) {
                this.openGroups = this.openGroups.filter(i => i !== index);
            } else {
                this.openGroups.push(index);
            }
        }
    }
};
</script>
